import highlightSlider from '../../components/sliders/highlightSlider';

document.querySelectorAll('[data-comp-highlight-slider]').forEach(slider => {
  new highlightSlider(slider);
});
